import {
  cleanRut,
  formatRut,
  sanitizeRut,
  validateRut
} from '@smuchile/pkg-unimarc-components/utils'
import { FormField, ValidationsType } from 'shared/interfaces/Form'

export const validateError = (
  formField: FormField,
  formFieldValue: unknown
) => {
  const value =
    formField?.validations === ValidationsType.RUT
      ? cleanRut(formFieldValue as string)
      : formFieldValue

  if (formField?.validations === ValidationsType.Email) {
    const emailRegex =
      /^(?:[a-zA-Z0-9._%+-]+)@(?:[a-zA-Z0-9.-]+\.)[a-zA-Z]{2,}$/
    return !emailRegex.test(value as string)
  }

  if (formField?.validations === ValidationsType.RUT) {
    return !validateRut(value as string)
  }

  if (formField?.minValue) {
    return (value as string)?.length < formField.minValue
  }

  if (formField?.maxValue) {
    return (value as string)?.length > formField.maxValue
  }

  return false
}

export const sanitizeInputValue = (
  value: string,
  formField: FormField
): string => {
  if (!value) return ''

  switch (formField.validations) {
    case ValidationsType.RUT:
      value =
        cleanRut(value).length < 10 ? formatRut(sanitizeRut(value)) : value
      break
    case ValidationsType.OnlyNumbers:
    case ValidationsType.PhoneNumber:
      value = value.replace(/\D/g, '')
      break
    case ValidationsType.OnlyText:
      value = value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '')
      break
  }

  if (
    formField.maxValue &&
    value.length > formField.maxValue &&
    formField.validations !== ValidationsType.RUT
  ) {
    value = value.slice(0, formField.maxValue)
  }

  return value
}
